// src/pages/FixSubheadings.js
import React, { useEffect } from 'react';
import { db } from '../firebase';
import { getDocs, collection, doc, updateDoc } from 'firebase/firestore';

const FixSubheadings = () => {
  useEffect(() => {
    const fixSubheadings = async () => {
      const snapshot = await getDocs(collection(db, 'dashContent'));
      let fixedAny = false;

      for (const docSnap of snapshot.docs) {
        const data = docSnap.data();
        if (!Array.isArray(data.fields)) continue;

        // Check if all fields have no subheading (bad format)
        const needsFix = data.fields.some((item) => item.fields && !item.subheading);

        if (needsFix) {
          const fixedFields = data.fields.map((item, i) => {
            if (item.fields && !item.subheading) {
              return {
                subheading: `Section ${i + 1}`,
                fields: item.fields,
              };
            }
            return item;
          });

          await updateDoc(doc(db, 'dashContent', docSnap.id), {
            fields: fixedFields,
          });

          console.log(`✅ Fixed "${data.name}" with ${fixedFields.length} subheading(s)`);
          fixedAny = true;
        }
      }

      if (fixedAny) {
        alert('✅ Subheadings fixed! You can now refresh your form.');
      } else {
        alert('✅ No fixes needed. Everything is structured correctly.');
      }
    };

    fixSubheadings();
  }, []);

  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>🛠 Fixing Missing Subheadings...</h2>
      <p>This tool automatically adds subheadings to any section that’s missing them.</p>
    </div>
  );
};

export default FixSubheadings;
